exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card.card-overflow {\n  overflow: visible; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/subscription/subscription-address/subscription-address.component.scss
// module id = ../../../../../src/app/components/subscription/subscription-address/subscription-address.component.scss
// module chunks = main